import React, { ReactNode } from "react";
import {
  DialogOverlay as ReachDialogOverlay,
  DialogContent as ReachDialogContent,
} from "@reach/dialog";
import { SystemProps, Icon, Box, Text, Stack } from "@storyofams/react-ui";
import { motion } from "framer-motion";

import Link from "next/link";
import styled from "styled-components";
import { ArrowRight, Close } from "~components/common/Icons";
import { CustomerDivider } from "../Header/CustomerDivider";

const MotionOverlay = motion(ReachDialogOverlay);
const MotionDialog = motion(ReachDialogContent);

const DialogOverlay = styled(MotionOverlay)<SystemProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: ${(p) => p.theme.zIndices.modal};

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.6);
  opacity: 0.75;
`;

const DialogContent = styled(MotionDialog)<{ children?: ReactNode }>`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 100%;
  background: transparent;
  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    max-width: 680px;
  }
`;

const ContentWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
  width: max-content;
  height: max-content;
`;
// export const BoxShadow = styled(Box)`
//   position: relative;
//   > :first-child {
//     background:
//     /* Shadow Cover TOP */ linear-gradient(
//           white 30%,
//           rgba(239, 0, 0, 0)
//         )
//         center top,
//       /* Shadow Cover BOTTOM */
//         linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
//       /* Shadow TOP */ linear-gradient(rgb(254, 76, 76), rgba(0, 0, 0, 0))
//         center top,
//       /* Shadow BOTTOM */ linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1))
//         center bottom;

//     background-repeat: no-repeat;
//     background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
//     background-attachment: local, local, scroll, scroll;
//   }
// `;

export const AddToCartModal = ({ product, isOpen, close }) => {
  return (
    <>
      {isOpen && (
        <DialogOverlay
          onDismiss={close}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 1 }}
        >
          <DialogContent
            aria-label={"image-modal"}
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            exit={{ y: -10 }}
          >
            <ContentWrapper
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 1 }}
            >
              <Box
                width={"680px"}
                bg="white"
                borderRadius={"8px"}
                p={[2, 5]}
                height={"max-content"}
                maxHeight={["calc(100vh - 80px)", "calc(100vh - 80px)"]}
                maxWidth={["calc(100vw - 32px)", "760px"]}
                overflow={"auto"}
              >
                <Stack
                  space={1}
                  justifyContent={"space-between"}
                  alignItems={"start"}
                >
                  <Text
                    fontFamily={"DINPro"}
                    fontWeight={700}
                    fontSize={["24px", "36px"]}
                    lineHeight={["29px", "43px"]}
                  >
                    {product.title}
                  </Text>
                  <Icon
                    cursor={"pointer"}
                    onClick={close}
                    pt={["5.5px", "10px"]}
                    fontSize={["16px", "26px"]}
                    icon={Close}
                  ></Icon>
                </Stack>
                <Link href={`/products/${product.handle}`}>
                  <Stack
                    cursor={"pointer"}
                    mb={3}
                    lineHeight={"25px"}
                    width={"max-content"}
                    mt={1}
                    borderBottom={"1px solid black"}
                    space={1}
                  >
                    <Text fontWeight={500} fontSize={"18px"}>
                      Bekijk Product
                    </Text>
                    <Icon fontSize={"18px"} icon={ArrowRight}></Icon>
                  </Stack>
                </Link>
                {/* <BoxShadow> */}
                <CustomerDivider
                  product={product}
                  isProductCard
                  close={close}
                  story={{ content: { isUpsellDisabled: false } }}
                />
                {/* </BoxShadow> */}
              </Box>
            </ContentWrapper>
          </DialogContent>
        </DialogOverlay>
      )}
    </>
  );
};
